import { render, staticRenderFns } from "./ConfigNotificationsGeneral.vue.js?vue&type=template&id=287064f3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigNotificationsGeneral.vue?vue&type=template&id=287064f3"
import script from "./ConfigNotificationsGeneral.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigNotificationsGeneral.vue?vue&type=script&lang=js"
export * from "./ConfigNotificationsGeneral.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ConfigNotificationsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports